import React from 'react'
import { LangModal, PhoneNumber } from '..';

import logo from '../../images/logo.svg'

const Header = () => {
    return (
            <div className="content__header">
                <span className="content__header-logo">
                    <a href={"https://vavsgroup.com/" + (localStorage.getItem('i18nextLng') === 'ru' ? 'ru/' : '') }>
                      <img src={logo}/>
                    </a>
                </span>
                <div className="content__header-rigth">
                    <PhoneNumber />
                    <LangModal />
                </div>
            </div>      
      
    )
}

export default Header